<template>
  <v-app>
    <lp-top
        :query-value="getQueryValue"
        :coupon-values="couponValues"
        :is-flyer-lp="isFlyerLp"
        :is-collab-lp="isCollabLp"
    >
      <template #collaborationDisplay>
        <collab-lp v-if="isFlyerLp || isCollabLp"
                   :query-value="getQueryValue"
                   :coupon-values="couponValues"
        >
        </collab-lp>
      </template>
      <template #loginButton>
        <v-btn
            class="d-flex mx-auto mb-6 mt-0 px-4 rounded-pill text-body-2 text-sm-body-1"
            :class="(isFlyerLp||isCollabLp) ? 'mb-8 mb-md-16' : 'mb-6'"
            :width="$vuetify.breakpoint.mdAndUp ? '419' : '343'"
            max-width="100%"
            height="64"
            href="/login"
        >
          会員登録済みの方はこちらからログイン
          <v-icon dence>mdi-chevron-right</v-icon>
        </v-btn>
      </template>

      <template #four-steps>
        <v-sheet id="four_steps_wrapper">
          <v-sheet class="accent2 justify-center flex-column pt-16 pb-16">
            <v-img contain max-width="372" class="mx-auto"
                   alt="ダンボールにいれて玄関で渡すだけ。"
                   :src="`${cdnUrl}/assets/images/sell/offer/offer-with-registration/4steps_logo_up.png`"/>
            <v-img contain max-width="360" class="accent2 mx-auto mt-3 mt-md-0"
                   alt="4ステップで完了！"
                   :src="`${cdnUrl}/assets/images/sell/offer/offer-with-registration/4steps_logo_down.png`"/>
          </v-sheet>

          <v-row no-gutters class="accent2 mb-1 px-16 pb-16">
            <v-col class="px-3">
              <v-card flat max-width="228px" class="accent2 justify-center ma-auto">
                <v-img
                    :src="`${cdnUrl}/assets/images/sell/offer/offer-with-registration/4-steps_step1.png`"/>
                <v-card-title class="text-subtitle-1 pa-0 mb-3 mt-10 justify-center font-weight-bold">ダンボールに本をいれる
                </v-card-title>
              </v-card>
            </v-col>
            <v-col>
              <v-card flat max-width="228px" class="accent2 justify-center ma-auto">
                <v-img
                    :src="`${cdnUrl}/assets/images/sell/offer/offer-with-registration/4-steps_step2.png`"/>
                <v-card-title class="text-subtitle-1 pa-0 mb-3 mt-10 justify-center font-weight-bold">Webで集荷を申し込む
                </v-card-title>
              </v-card>
            </v-col>
            <v-col>
              <v-card flat max-width="228px" class="accent2 justify-center ma-auto">
                <v-img
                    :src="`${cdnUrl}/assets/images/sell/offer/offer-with-registration/4-steps_step3.png`"/>
                <v-card-title class="text-subtitle-1 pa-0 mb-3 mt-10 justify-center font-weight-bold">玄関でお渡し
                </v-card-title>
              </v-card>
            </v-col>
            <v-col>
              <v-card flat max-width="228px" class="accent2 justify-center ma-auto">
                <v-img
                    :src="`${cdnUrl}/assets/images/sell/offer/offer-with-registration/4-steps_step4.png`"/>
                <v-card-title class="text-subtitle-1 pa-0 mb-3 mt-6 justify-center font-weight-bold">査定結果を確認したら<br/>振込完了！
                </v-card-title>
              </v-card>
            </v-col>
          </v-row>
        </v-sheet>
      </template>

      <template #value-feature>
        <v-sheet tag="section" class="pt-16 px-7 accent2" id="vb_three_features">
          <v-row no-gutters class="justify-center">
            <svg class="vb-logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 246.64 139.66">
              <g>
                <path class="cls-1"
                      d="M246.61,105.71a34.58,34.58,0,0,1-3.22,16.62,28.71,28.71,0,0,1-14,13.77c-6.95,3.09-18.55,3.55-24.84,3.55-2.05,0-4.08,0-6-.13l-11.78,0-10.71,0h-8.1l-4.65,0h-.22c-.57,0-1.45,0-2.36-.05s-1.91-.06-2.58-.06h-.32c-2.71.06-5.42,0-7.58-.08a1.2,1.2,0,0,1-1.13-1.18c0-1.29,0-6.39,0-11.33,0-3.42,0-6.72,0-8.51,0-1,.07-3.71.08-5.91,0-1.48,0-2.79,0-3.34l-.07-28.83V55.27c0-1.76,0-8.08,0-9.49.06-1.16.05-2.23,0-3.36s0-2.53,0-3.93c.14-2.38.14-4.87.14-7.06v-.25a1.2,1.2,0,0,1,1.07-1.2,11.35,11.35,0,0,1,1.76,0l1,0h10.38c2.83,0,7.07,0,11.49,0l13,0,12.28,0c2.36-.07,5.27,0,7.9.06a51.29,51.29,0,0,1,6,.45c8.38,1.12,15,4.63,19.16,10.16,2.33,3.1,3.92,6.76,5.17,11.87a24.65,24.65,0,0,1,.39,7.16,27,27,0,0,1-2.53,9.2A20.51,20.51,0,0,1,229,76.7l-.13.07-1,.48a44.13,44.13,0,0,1,4,2.24c3.83,2.71,8.54,6.56,11.48,12.72a32,32,0,0,1,3.13,11.11v.12c0,.3,0,.7.07,1.1s0,.86.06,1.17m-76.1,15.5h.55l.83,0h.5l8.7.11,9.84.12c2.87.15,5.33.13,8.83.12H202a39.58,39.58,0,0,0,5-.25c7.23-.87,12-3.21,14.5-7.16a19.28,19.28,0,0,0,2.49-6.92,15.12,15.12,0,0,0-1.62-9.74,17.08,17.08,0,0,0-5-5.86,7,7,0,0,0-1.24-.72,19.49,19.49,0,0,0-3-1.22,23.39,23.39,0,0,0-4.51-1c-4.67-.51-11.78-.57-16.72-.57-3,0-6,0-8.86,0-4.68,0-9,.08-12.09,0h-.54c0,1.67-.06,4.14-.06,5.44,0,.07,0,.59,0,1.44.06,4.14.2,15.12.16,18v6.62A12.59,12.59,0,0,1,170.51,121.21ZM216.07,55.7c-2.73-7.37-9.13-8.1-19.35-8.42l-1.35,0h-1.92c-4,.09-11.55.21-17.25.3l-5.58.09c0,.62,0,1.2,0,1.8,0,1,0,2,0,3.34,0,2.24,0,4.35,0,6.79,0,1.32,0,2.76.07,4.38,0,1.1,0,4,0,5.62l1.22,0c1.07,0,4.6.06,8,.08l5.16,0,4.48,0,4.51,0c.7,0,1.38,0,2.06,0,5.86,0,10.61-.49,13.37-1.37a11.53,11.53,0,0,0,4.3-2.48,6.42,6.42,0,0,0,.92-1l.28-.45a9.12,9.12,0,0,0,1.37-2.88A12.67,12.67,0,0,0,216.07,55.7ZM117.52,30.31a1.18,1.18,0,0,0-1.07-.69H93.85a1.16,1.16,0,0,0-1,.52A257.58,257.58,0,0,0,71.69,67.28,301.21,301.21,0,0,0,58.81,99.81,299.19,299.19,0,0,0,45.92,67.28,257.54,257.54,0,0,0,24.74,30.14a1.17,1.17,0,0,0-1-.52H1.19a1.18,1.18,0,0,0-1.07.69,1.23,1.23,0,0,0,.14,1.28,224.64,224.64,0,0,1,27.2,44.6,291.08,291.08,0,0,1,20.65,62.52,1.2,1.2,0,0,0,1.17.95h19a1.21,1.21,0,0,0,1.17-.95A291.25,291.25,0,0,1,90.16,76.19a226,226,0,0,1,27.22-44.6A1.23,1.23,0,0,0,117.52,30.31Zm-75-15.89a7.15,7.15,0,0,0,7.09-7.21,7.1,7.1,0,1,0-14.19,0A7.16,7.16,0,0,0,42.49,14.42Zm32.66,0a7.16,7.16,0,0,0,7.1-7.21,7.1,7.1,0,1,0-14.19,0A7.16,7.16,0,0,0,75.15,14.42Zm97.8,0A7.15,7.15,0,0,0,180,7.21a7.1,7.1,0,1,0-14.19,0A7.16,7.16,0,0,0,173,14.42Zm32.67,0a7.16,7.16,0,0,0,7.09-7.21,7.1,7.1,0,1,0-14.19,0A7.16,7.16,0,0,0,205.62,14.42Z"/>
              </g>
            </svg>
          </v-row>
          <v-row no-gutters class="justify-center mb-10 mt-3">
            <v-img max-width="258" max-height="60"
                   :src="`${cdnUrl}/assets/images/sell/offer/unauthenticated/firstLP_feature_text.svg`"/>
          </v-row>
          <v-row
              :no-gutters="$vuetify.breakpoint.smAndDown"
              class="mx-auto d-md-flex mb-md-5"
              justify-md="space-between"
              :class="$vuetify.breakpoint.mdAndUp ? 'fixed-width' : ''"
          >
            <v-col class="pl-md-0 mb-5 col-12 col-md-4">
              <v-card class="pa-10 mb-4 rounded-lg elevation-0" height="96%">
                <v-img class="mx-auto mb-6" max-width="80" max-height="64"
                       :src="`${cdnUrl}/assets/images/sell/offer/unauthenticated/icon_yen.svg`"/>
                <v-card-title class="text-subtitle-1 pa-0 mb-3 justify-center font-weight-bold">業界トップクラスの買取額
                </v-card-title>
                <v-card-text class="text-subtitle-2 pa-0 justify-center">
                  倉庫業務を効率化し人件費を抑えることで、業界トップクラスの価格で買取ます。
                </v-card-text>
              </v-card>
            </v-col>
            <v-col class="mb-5 col-12 col-md-4">
              <v-card class="pa-10 mb-4 rounded-lg elevation-0" height="96%">
                <v-img class="mx-auto mb-6" max-width="80" max-height="64"
                       :src="`${cdnUrl}/assets/images/sell/offer/unauthenticated/icon_free.svg`"/>
                <v-card-title class="text-subtitle-1 pa-0 mb-3 justify-center font-weight-bold">返送料が無料
                </v-card-title>
                <v-card-text class="text-subtitle-2 pa-0 justify-center">査定額にご満足いただけなかった場合、返送料は不要でお返しします。
                  ※査定後すぐにお振込みをご希望の方は返送できません。
                </v-card-text>
              </v-card>
            </v-col>
            <v-col class="pr-md-0 mb-5 col-12 col-md-4">
              <v-card class="pa-10 mb-4 rounded-lg elevation-0" height="96%">
                <v-img class="mx-auto mb-6" max-width="80" max-height="64"
                       :src="`${cdnUrl}/assets/images/sell/offer/unauthenticated/icon_meisai.svg`"/>
                <v-card-title class="text-subtitle-1 pa-0 mb-3 justify-center font-weight-bold">買取明細が見られる
                </v-card-title>
                <v-card-text class="text-subtitle-2 pa-0 justify-center">どの本はいくらだったのか、買い取った本の明細をきちんとお出しします。
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-sheet>
      </template>
      <template #latest-estimated-price-info v-if="this.vbOfficialItems.folderItems.length != 0">
        <v-sheet id="list_with_estimatedprice" class="list-with-estimatedprice">
          <p class="accent2 mt-md-n5 mb-0 pt-6 pt-md-9 text-subtitle-1 text-md-h5 text-center font-weight-bold pb-10"
             style="color:#0095D9;">
            今が旬、買取商品アイテム一覧
          </p>
          <v-sheet
              class="mx-0 mx-md-auto pb-8 accent2 d-flex flex-wrap px-0 px-md-16"
              :class="showScrollableList ? 'mb-7' : 'mb-10'"
          >
            <p class="accent2 mb-0 pt-0 text-caption px-6 text-left pb-5">
              買取参考価格は“キズや使用感はあるが概ね良好“な状態を想定した価格です。また実際の買取価格は、本の状態や時期によって変動いたします。<br>
              ※姉妹サイトVabooや、チャリボンも同じ価格です。
            </p>
            <v-sheet v-if="showScrollableList" class="accent2" style="width:100%;">
              <v-slide-group
                  id="scrollable_estimate_list"
                  show-arrows
              >
                <v-slide-item
                    v-for="(item,n) in vbOfficialItems.folderItems"
                    :key="n"
                >
                  <vb-item-estimate-price :item="item" :showSpeechBubble="false"></vb-item-estimate-price>
                </v-slide-item>
              </v-slide-group>
            </v-sheet>
            <template v-else v-for="(item,n) in vbOfficialItems.folderItems">
              <vb-item-estimate-price :item="item" :showSpeechBubble="true"></vb-item-estimate-price>
            </template>
          </v-sheet>
        </v-sheet>
      </template>

      <template #couponBenefit>
        <coupon-benefit-label>
          <template #loginBtn>
            <v-btn
                class="d-flex mx-auto mt-5 text-caption rounded-pill"
                href="/login"
                width="256"
            >
              会員登録済みの方はこちらからログイン
            </v-btn>
          </template>
        </coupon-benefit-label>
      </template>
    </lp-top>

    <validation-observer ref="observer" v-slot="observerProps">
      <items-remaining
          :show="((observerProps.touched && observerProps.invalid) || (isBackFromConfirmation && observerProps.invalid)) && isIntersecting"
          :numberOfRemaining="countInvalidFields(observerProps.fields)"
      />
      <register-form
          :pickup-request-cut-off-time-offset-in-hours="-1"
          :max-number-of-packages="maxNumberOfPackages"
          v-intersect="onIntersect"
      >
        <template #buybackCode>
          <vb-buyback-code
              :form-items-setter="setBuyFormItems"
              :form-items-getter="{buybackCode: getBuyFormItems.buybackCode}"
          />
        </template>
        <template #mail-address>
          <vb-mail-address
              :form-items-setter="setMemberFormItems"
              :form-items-getter="{
            email: getMemberFormItems.email,
            isAgreedCreateMainSiteAccount: getMemberFormItems.isAgreedCreateMainSiteAccount
          }"
          >
            <template #email-annotation>
              <p class="text-caption grey--text text--darken-4 mb-0 pt-3 pl-0">valuebooks.jp および value-books.jp
                ドメインからのメール受信を許可するよう設定ください</p>
            </template>
          </vb-mail-address>
        </template>
        <template #password>
          <vb-password
              :form-items-setter="setMemberFormItems"
              :form-items-getter="{
              password: getMemberFormItems.password,
              passwordConfirmation: getMemberFormItems.passwordConfirmation,
              isAgreedCreateMainSiteAccount: getMemberFormItems.isAgreedCreateMainSiteAccount
            }"
          />
        </template>
        <template #terms-of-service>
          <vb-terms-of-service
              :form-items-setter="setMemberFormItems"
              :form-items-getter="{
              isAgreedWithTermsAndPrivacy: getMemberFormItems.isAgreedWithTermsAndPrivacy,
              isAgreedCreateMainSiteAccount: getMemberFormItems.isAgreedCreateMainSiteAccount,
            }"
          />
        </template>
        <template #email-subscription>
          <vb-email-subscription
              :form-items-setter="setMemberFormItems"
              :is-required-email-subscription="true"
              :form-items-getter="{emailSubscriptionCode: getMemberFormItems.emailSubscriptionCode}"
          >
          </vb-email-subscription>
        </template>
        <template #non-invoice-consent>
          <vb-non-invoice-consent
              :form-items-setter="setMemberFormItems"
              :form-items-getter="{nonInvoiceConsent: getMemberFormItems.nonInvoiceConsent}"
          >
          </vb-non-invoice-consent>
        </template>

        <template #button>
          <v-row justify="center">
            <v-btn
                class="secondary white--text text-subtitle-1 text-md-h6 text-md-h6"
                :width="$vuetify.breakpoint.mdAndUp ? '500px' : '328px'"
                :height="$vuetify.breakpoint.mdAndUp ? '76px' : '48px'"
                :disabled="observerProps.invalid"
                @click="goToConfirm"
            >
              内容を確認する
            </v-btn>
          </v-row>
        </template>
        <template #identityHint>
          古物営業法に基づき、本人確認手続きが必要です。<br/>
          お申込み後、マイページの身分証登録からアップロードしてください。
        </template>
        <template #identityAnnotation>
          ご利用できる身分証は<a class="accent--text text-decoration-underline" href="/sell/faq#faq-id-card"
                                 target="_blank">こちら</a>
        </template>
      </register-form>
    </validation-observer>
  </v-app>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import LpTop from "../../organisms/buy/lp-top.vue";
import CollabLp from "../../organisms/buy/collab-lp.vue";
import RegisterForm from "../../template/register-form.vue";
import VbBuybackCode from "../../molecules/form/vb-buyback-code.vue";
import VbPassword from "../../molecules/form/vb-password.vue";
import VbEmailSubscription from "../../molecules/form/agreed/vb-email-subscription.vue";
import VbMailAddress from "../../molecules/form/vb-mail-address.vue";
import ItemsRemaining from "../../molecules/items-remaining.vue";
import VbTermsOfService from "../../molecules/form/agreed/vb-terms-of-service.vue";
import CouponBenefitLabel from "../../molecules/buy/coupon-benefit-label.vue";
import VbItemEstimatePrice from "../../molecules/vb-item-estimate-price.vue";
import SlideItem from "../../organisms/top/slide-item.vue";
import VbNonInvoiceConsent from "../../molecules/form/agreed/vb-non-invoice-consent.vue";

import itemListConfig from '../../../config/itemlist.js';

export default {
  name: "quick-entry-vb-form",
  components: {
    VbNonInvoiceConsent,
    CouponBenefitLabel,
    ItemsRemaining,
    VbMailAddress,
    VbEmailSubscription,
    VbPassword,
    VbBuybackCode,
    RegisterForm,
    CollabLp,
    LpTop,
    VbTermsOfService,
    VbItemEstimatePrice,
    SlideItem,
  },
  data() {
    return {
      isVisible: true,
      cdnUrl: VueConfig.cdn_url,
      isIntersecting: false,
      maxNumberOfPackages: VueConfig.sell.maxNumberOfPackages,
      couponValues: {// クーポンコードの値は英字小文字で記載
        default: {
          mainImgUrlPc: "/assets/images/sell/offer/offer-with-registration/lp-main-orange-240730.png",
          mainImgUrlSp: "/assets/images/sell/offer/offer-with-registration/lp-main-orange-240730-sp.png",
          loginBtnColor: "light-green darken-4",
          imgRatioTopPc: 2560 / 1128,
          imgRatioTopSp: 780 / 1220,
        },
        uka2212: {
          mainImgUrlPc: "/assets/images/sell/offer/offer-with-registration/collab/uka_main_pc.jpg",
          mainImgUrlSp: "/assets/images/sell/offer/offer-with-registration/collab/uka_main_sp.jpg",
          loginBtnColor: "amber darken-1",
          imgRatioTopPc: 5333 / 1833,
          imgRatioTopSp: 1562 / 1896,
        },
        keirindo: {
          mainImgUrlPc: "/assets/images/sell/offer/offer-with-registration/collab/keirindo_main_pc.png",
          mainImgUrlSp: "/assets/images/sell/offer/offer-with-registration/collab/keirindo_main_pc.png",
          loginBtnColor: "green darken-1",
          imgRatioTopPc: 2384 / 1378,
          imgRatioTopSp: 2384 / 1378,
        },
        metro2212: {
          mainImgUrlPc: "/assets/images/sell/offer/offer-with-registration/collab/metromin_main_pc.jpg",
          mainImgUrlSp: "/assets/images/sell/offer/offer-with-registration/collab/metromin_main_sp.jpg",
          loginBtnColor: "cyan accent-4",
          imgRatioTopPc: 2560 / 880,
          imgRatioTopSp: 800 / 971,
        },
        ra_fl_001a: {
          mainImgUrlPc: "/assets/images/sell/offer/offer-with-registration/rakuten_main_pc.png",
          mainImgUrlSp: "/assets/images/sell/offer/offer-with-registration/rakuten_main_sp.png",
          mainBgColor: "accent2",
          imgRatioTopPc: 2560 / 754,
          imgRatioTopSp: 1131 / 1209,
        },
        ra_fl_002a: {
          mainImgUrlPc: "/assets/images/sell/offer/offer-with-registration/rakuten_main_pc.png",
          mainImgUrlSp: "/assets/images/sell/offer/offer-with-registration/rakuten_main_sp.png",
          mainBgColor: "accent2",
          imgRatioTopPc: 2560 / 754,
          imgRatioTopSp: 1131 / 1209,
        },
        vb_fl_001a: {},
        vb_fl_002a: {
          mainImgUrlPc: "/assets/images/sell/offer/offer-with-registration/vb02-main-pc-0502.png",
          mainImgUrlSp: "/assets/images/sell/offer/offer-with-registration/vb02-main-sp-0502.png",
          mainBgColor: "accent2",
          imgRatioTopPc: 2560 / 880,
          imgRatioTopSp: 750 / 800,
        },
        xd_fl_001a: {
          mainImgUrlPc: "/assets/images/sell/offer/offer-with-registration/collab/oisix_main_pc.png",
          mainImgUrlSp: "/assets/images/sell/offer/offer-with-registration/collab/oisix_main_sp.png",
          imgRatioTopPc: 2560 / 1128,
          imgRatioTopSp: 780 / 1388,
        },
      },
      apiForEstimatePrice: VueConfig.estimate_url,
      vbOfficialItems: {
        folderDetails: {},
        folderItems: []
      },
      numberOfDisplayItemsPc: 10,
      numberOfDisplayItemsSp: 20,
      folderItemsLatter: [],
    }
  },
  props: {},
  provide: function () {
    //子コンポーネントでエラーをセットするため
    return {
      setErrors: this.observeSetErrors
    }
  },
  created() {
    this.setBuyFormItems({name: 'site_code', value: this.$siteCode});
    // 送料無料自動適用 強制適用ではなくなったため
    // this.setBuyFormLabels({name: 'isShippingFreeAutoApplication', value: true});

    // 査定額込で表示する書籍をライブラリから取得
    const officialLibraryFolderIDKey = Object.keys(itemListConfig.officialLibraryFolderIds[0])[1];
    this.retrieveOfficialLibraryItem(officialLibraryFolderIDKey, 'vbOfficialItems');

    // cookie にpattern の値をセット
    let pattern_query = new URLSearchParams(window.location.search).get('pattern')
    if (!!pattern_query) {
      this.setPatternCookie(pattern_query);
    }

    // URLパラメータの値をセット
    this.setUrlParameterValues().then((status) => {
      // 入力補完がある場合はバリデーションを実行
      if (status) {
        this.$refs.observer.validate();
      }
    });

  },
  computed: {
    ...mapGetters({
      getMemberFormItems: 'member/getFormItems',
      getBuyFormItems: 'buy/getFormItems',
    }),
    countInvalidFields: function () {
      return function (fields) {
        let count = 0;
        for (let key of Object.keys(fields)) {
          !fields[key].valid && count++
        }
        return count;
      }
    },

    hasPatternCookie() {
      return document.cookie.split(';').some(function (item) {
        return item.trim().startsWith('lp_pattern=');
      });
    },
    patternValueOnCookie() {
      if (this.hasPatternCookie) {
        let pattern_cookie = document.cookie.split(';').find(function (item) {
          return item.trim().startsWith('lp_pattern=');
        }).split('=')[1];
        return this.makeLowerCase(pattern_cookie);
      } else {
        return null;
      }
    },
    isCollabLp() {
      const queryValues = Object.keys(this.couponValues);
      let givenQuery = this.fetchUniqueQuery(this.$route.query.couponcode);
      if (!!givenQuery && queryValues.includes(givenQuery)) {
        return true;
      } else {
        return false;
      }
    },
    isFlyerLp() {
      const queryValues = Object.keys(this.couponValues);
      let givenQuery = this.fetchUniqueQuery(this.$route.query.pattern);
      if ((!!givenQuery && queryValues.includes(givenQuery)) || (!!this.patternValueOnCookie && queryValues.includes(this.patternValueOnCookie))) {
        return true;
      } else {
        return false;
      }
    },
    getQueryValue() {// pattern(on url query) > pattern(on cookie) > couponcode の優先度で値を取得
      if (this.isFlyerLp) {
        if (this.$route.query.pattern) {
          return this.makeLowerCase(this.$route.query.pattern);
        } else if (this.hasPatternCookie) {
          return this.makeLowerCase(this.patternValueOnCookie);
        }
      } else if (this.isCollabLp && this.$route.query.couponcode) {
        return this.makeLowerCase(this.$route.query.couponcode);
      } else {
        return 'default';
      }
    },
    showScrollableList() {
      return this.$vuetify.breakpoint.xs;
    },
    sliceItems() {
      if (!this.showScrollableList) {
        this.folderItemsLatter = this.vbOfficialItems.folderItems.slice(this.numberOfDisplayItemsPc);
        this.vbOfficialItems.folderItems = this.vbOfficialItems.folderItems.slice(0, this.numberOfDisplayItemsPc);
      } else {
        this.vbOfficialItems.folderItems = [...this.vbOfficialItems.folderItems, ...this.folderItemsLatter];
      }
    },
  },
  methods: {
    // URLパラメータにpattern がある場合cookie にセットするメソッド
    setPatternCookie(urlQueryValue) {
      const hour = 3; // cookieの有効期限(h)
      const keyValue = urlQueryValue;

      let date = new Date();
      date.setTime(date.getTime() + (hour * 60 * 60 * 1000));

      document.cookie = 'lp_pattern=' + keyValue + ';expires=' + date + ';path=/';
    },
    fetchUniqueQuery(param) {
      let uniqueQuery;
      if (param) {
        if (typeof param == 'string') {
          uniqueQuery = param.toLowerCase();
        } else if (param[0]) {
          uniqueQuery = param[0].toLowerCase();
        } else {
          uniqueQuery = null;
        }
      }
      return uniqueQuery;
    },
    makeLowerCase(param) {// クーポンコードの値を小文字に変換:クエリが複数の場合は一番目を取得
      if (typeof param == 'string') {
        return param.toLowerCase();
      } else if (param[0]) {
        return param[0].toLowerCase();
      } else {
        return null;
      }
    },
    ...mapActions({
      setMemberFormItems: 'member/updateFormItems',
      setBuyFormItems: 'buy/updateFormItems',
      setBuyFormLabels: 'buy/updateFormLabels',
      isValidatePickupTime: 'buy/isValidatePickupTime',
      retrieveCouponCode: 'buy/retrieveCouponCode',
      setUrlParameterValues: 'buy/setUrlParameterValues',
    }),
    async goToConfirm() {

      //クーポンチェック
      const result_coupon = await this.retrieveCouponCode();
      if (!result_coupon.status) {
        this.observerErrorHandle("クーポンコード", result_coupon.errorMsg);
        return
      }

      //集荷日チェック
      const response_pickup_date = await this.isValidatePickupTime()
      if (!response_pickup_date) {
        this.observerErrorHandle("日にち", "ご指定の集荷希望日は選択できません。");
        return
      }

      this.$router.push({name: "QuickEntryVbConfirm"});
    },
    observeSetErrors(name, errorMessage) {
      let params = {};
      params[name] = errorMessage;
      this.$refs.observer.setErrors(params);
    },
    scrollBehavior(position) {
      this.$vuetify.goTo(position, {
        duration: 300,
        offset: window.innerHeight / 2,
        easing: 'easeInOutCubic'
      })
    },
    scrollTargetNode(name) {
      return this.$refs.observer.refs[name].$el;
    },
    observerErrorHandle(name, message) {
      this.observeSetErrors(name, message);
      this.scrollBehavior(this.scrollTargetNode(name));
    },
    isBackFromConfirmation() {
      return this.$route.params.isBackButton;
    },
    onIntersect(entries, observer) {
      this.isIntersecting = entries[0].isIntersecting
    },

    retrieveOfficialLibraryItem(folderIDKey, resultDestination) {
      const api = "/api/library/OfficialFolder/items";
      let _this = this;
      let resultContainer = resultDestination;

      axios.get(api, {
        params: {
          folderIDKey: folderIDKey,
          numberOfItems: Math.max(this.numberOfDisplayItemsPc, this.numberOfDisplayItemsSp),
        }
      })
          .then(({data}) => {
            if (data) {
              let displayItems = data.items.slice(0, Math.max(this.numberOfDisplayItemsPc, this.numberOfDisplayItemsSp));
              if (!displayItems.length) {
                return;
              }
              _this[resultContainer].folderItems.push(...displayItems);
              _this[resultContainer].folderDetails = data.details;
            }
          })
          .catch((error) => {
            console.debug(error);
          })
    },
  },
  mounted() {
    if (this.$route.params.validate_on_load) {
      this.$refs.observer.validate();
    }
    // 確認画面で集荷日時のエラーになった場合に表示する
    if (this.$route.params.pickup_date_error) {
      this.observerErrorHandle("日にち", "ご指定の集荷希望日は選択できません。");
    }
  },
}
</script>

<style scoped lang="scss">
.fixed-width {
  max-width: 1024px;
}

.row {
  margin: 0;
}

.description {
  word-break: keep-all;
}

svg.vb-logo {
  width: 48px;
  height: 27px;
  fill: #58A0C1;
}

::v-deep {
  .row {
    &.email-subscription {
      display: none;
    }
  }

  @media screen and (max-width: 959px) {
    .main-image {
      .v-responsive__sizer {
        padding-bottom: 100% !important;
      }
    }
  }

  .v-messages__message {
    line-height: 1.2em;
  }

  .v-text-field__details {
    padding: 4px 0 0 !important;
  }
}

.list-with-estimatedprice {
  display: none;
}
</style>